import React from 'react';
import { InstagramIcon, YoutubeIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  const stores = [{
    name: 'Caversham',
    phone: '9377 1270',
    address: 'Cnr Benara Rd & Lord St'
  }, {
    name: 'Kelmscott',
    phone: '9390 4290',
    address: '8/2938 Albany Hwy'
  }, {
    name: 'Malaga',
    phone: '9249 3125',
    address: '3/673 Marshall Rd'
  }, {
    name: 'Midland',
    phone: '9250 2612',
    address: '1 Clayton St'
  }, {
    name: 'Wangara',
    phone: '9309 3320',
    address: '2/21 Prindiville Dr'
  }, {
    name: 'Whitfords',
    phone: '9401 3100',
    address: '15 Banks Ave'
  }];
  return <footer className="bg-[#002faa] text-white pt-20 pb-8 relative overflow-hidden" data-id="element-377">
      {/* Subtle paw print watermark */}
      <div className="absolute top-10 right-10 w-64 h-64 opacity-5 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/8QwuRvfxBY7HY1xAguEFR2/Picturea11.png)',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-378"></div>

      <div className="container-wide relative z-10" data-id="element-379">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8 mb-16" data-id="element-380">
          {/* Col 1: Brand */}
          <div className="lg:col-span-4 pr-0 lg:pr-8" data-id="element-381">
            <div className="flex items-center gap-4 mb-6" data-id="element-382">
              <div className="bg-white p-3 rounded-2xl inline-block shadow-sm" data-id="element-383">
                <img src="https://cdn.magicpatterns.com/uploads/dmbfFx8UTLKDZ7YQXuKt3w/BPAG_website_logo.svg" alt="Better Pets and Gardens" className="h-12 object-contain" data-id="element-384" />
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/cHcSSRvAwPTr86uE9Kk5yi/WA_OWned.webp" alt="Western Australian Owned" className="h-14 w-14 rounded-full object-cover shadow-sm" data-id="element-385" />
            </div>
            <p className="text-white/80 text-base mb-8 leading-relaxed" data-id="element-386">
              Your local experts for pets, gardens and pools. Proudly 100% WA
              owned and operated with six locations across Perth.
            </p>
            <div className="flex items-center gap-4" data-id="element-387">
              <a href="https://www.facebook.com/BetterPetsandGardens" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white/80 hover:bg-[#1877F2] hover:text-white transition-all hover:scale-110 active:scale-95" aria-label="Facebook" data-id="element-388">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-389">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-390" />
                </svg>
              </a>
              <a href="#" className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white/80 hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-500 hover:text-white transition-all hover:scale-110 active:scale-95" aria-label="Instagram" data-id="element-391">
                <InstagramIcon className="w-5 h-5" data-id="element-392" />
              </a>
              <a href="#" className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white/80 hover:bg-red-600 hover:text-white transition-all hover:scale-110 active:scale-95" aria-label="YouTube" data-id="element-393">
                <YoutubeIcon className="w-5 h-5" data-id="element-394" />
              </a>
            </div>
          </div>

          {/* Col 2: Our Stores */}
          <div className="lg:col-span-4" data-id="element-395">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-396">
              Our Stores
            </h4>
            <ul className="space-y-4" data-id="element-397">
              {stores.map(store => <li key={store.name} data-id="element-398">
                  <div className="text-white/90 hover:text-white transition-colors" data-id="element-399">
                    <div className="flex items-center gap-2 font-bold mb-1" data-id="element-400">
                      <MapPinIcon className="w-4 h-4 text-brand-green" data-id="element-401" />
                      {store.name}
                    </div>
                    <div className="flex items-center gap-2 text-sm text-white/70 ml-6" data-id="element-402">
                      <PhoneIcon className="w-3 h-3" data-id="element-403" />
                      {store.phone}
                    </div>
                    <div className="text-sm text-white/70 ml-6" data-id="element-404">
                      {store.address}
                    </div>
                  </div>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Shop Links */}
          <div className="lg:col-span-2" data-id="element-405">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-406">
              Shop
            </h4>
            <ul className="space-y-4" data-id="element-407">
              <li data-id="element-408">
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-409">
                  Dogs and Puppies
                </a>
              </li>
              <li data-id="element-410">
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-411">
                  Cats and Kittens
                </a>
              </li>
              <li data-id="element-412">
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-413">
                  Birds and Poultry
                </a>
              </li>
              <li data-id="element-414">
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-415">
                  Fish and Aquarium
                </a>
              </li>
              <li data-id="element-416">
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-417">
                  Small Animals
                </a>
              </li>
              <li data-id="element-418">
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-419">
                  Garden Care
                </a>
              </li>
              <li data-id="element-420">
                <a href="#" className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-421">
                  Pools and Spas
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Connect */}
          <div className="lg:col-span-2" data-id="element-422">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-423">
              Connect
            </h4>
            <div className="bg-white/10 rounded-2xl p-6 border border-white/20" data-id="element-424">
              <p className="text-white/80 text-sm mb-4 leading-relaxed" data-id="element-425">
                Join our newsletter for expert tips and exclusive offers.
              </p>
              <form className="mb-4" onSubmit={e => e.preventDefault()} data-id="element-426">
                <div className="relative mb-3" data-id="element-427">
                  <input type="email" placeholder="Email address" className="w-full bg-white/10 border border-white/30 rounded-xl py-3 pl-11 pr-4 text-white placeholder-white/50 focus:outline-none focus:border-brand-green focus:ring-1 focus:ring-brand-green transition-all" data-id="element-428" />
                  <MailIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/50" data-id="element-429" />
                </div>
                <button className="w-full bg-brand-blue hover:bg-brand-blue-600 text-white font-heading font-semibold py-3 rounded-xl transition-colors shadow-blue-glow active:scale-98" data-id="element-430">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="py-6 border-t border-white/10 mb-6 flex flex-col lg:flex-row items-center justify-between gap-6" data-id="element-431">
          <div className="flex items-center gap-3 flex-wrap justify-center" data-id="element-432">
            <span className="text-sm text-white/70 font-medium mr-2" data-id="element-433">
              We accept:
            </span>
            <div className="flex gap-2 flex-wrap" data-id="element-434">
              <span className="bg-white/10 px-3 py-1 rounded-md text-xs text-white/80 font-medium border border-white/20" data-id="element-435">
                Visa
              </span>
              <span className="bg-white/10 px-3 py-1 rounded-md text-xs text-white/80 font-medium border border-white/20" data-id="element-436">
                Mastercard
              </span>
              <span className="bg-white/10 px-3 py-1 rounded-md text-xs text-white/80 font-medium border border-white/20" data-id="element-437">
                Amex
              </span>
              <span className="bg-[#B2FCE4] text-[#000000] px-3 py-1 rounded-md text-xs font-bold border border-[#B2FCE4]" data-id="element-438">
                afterpay
              </span>
              <span className="bg-white/10 px-3 py-1 rounded-md text-xs text-white/80 font-medium border border-white/20" data-id="element-439">
                Zip
              </span>
            </div>
          </div>

          <div className="text-sm text-white/70 font-medium" data-id="element-440">
            www.betterpetsandgardens.com.au
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-441">
          <p className="text-white/60 text-sm" data-id="element-442">
            © 2026 Better Pets and Gardens. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-443">
            <a href="#" className="text-white/60 hover:text-white text-sm transition-colors" data-id="element-444">
              Privacy Policy
            </a>
            <a href="#" className="text-white/60 hover:text-white text-sm transition-colors" data-id="element-445">
              Terms of Service
            </a>
            <a href="#" className="text-white/60 hover:text-white text-sm transition-colors" data-id="element-446">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* Green accent strip at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-brand-green" data-id="element-447"></div>
    </footer>;
}